module.exports = __webpack_public_path__ + "static/modernizace-php-aplikaci-3-7fa72d7b25aa1a3d5d60727759790260.jpg";